import React, { Component, Fragment } from 'react';
import { localize } from 'react-localize-redux';

import { AccentColor } from 'helpers/AccentColorHelper';
import FooterButtons from 'components/shared/FooterButtons';
import TabbedPanel from 'components/shared/TabbedPanel';
import { drawerStyles } from 'helpers/StyleHelper';

import EventAndNoticeCard from './eventsAndNotices/EventAndNoticeCard';

let NoticesDrawer = class extends Component {
  render() {
    const tabBodies = [this.renderDetailsBody()];
    const tabFooters = [this.renderCloseOnlyFooter()];
    drawerStyles.tabbedHeaderWrapper = {
      ...drawerStyles.tabbedHeaderWrapper,
      borderBottom: '2px solid ' + AccentColor(),
      height: '63px',
    };
    return (
      <Fragment>
        <div className="row" style={drawerStyles.tabbedHeaderWrapper}>
          <h3 style={drawerStyles.tabbedHeader}>{this.props.headerVerbiage}</h3>
        </div>

        <TabbedPanel tabBodies={tabBodies} tabFooters={tabFooters} />
      </Fragment>
    );
  }

  renderDetailsBody = () => {
    return (
      <div style={{ height: 'calc(100% - 61px)', overflow: 'scroll', padding: ' 0 15px 15px' }}>
        <div className="row">{this.renderEventsOrNotices()}</div>
      </div>
    );
  };

  renderCloseOnlyFooter = () => {
    return (
      <FooterButtons
        hideSubmitButton
        backName={this.props.translate('close')}
        backAction={this.props.toggleDrawer}
      />
    );
  };

  renderEventsOrNotices = () => {
    if (!this.props.buildingEventsOrNotices) return;

    return this.props.buildingEventsOrNotices.map((eventAndNotice, index) => {
      return (
        <EventAndNoticeCard
          key={index}
          eventAndNotice={eventAndNotice}
          base64String={this.props.base64String}
        />
      );
    });
  };
};

export default localize()(NoticesDrawer);
